export class LocalStorageUtils {
  static LOCAL_STORAGE_KEY = {
    AUTH_TOKEN: "authToken",
    AREA_ID: "areaId",
    AREA_NAME: "areaName",
    AREA: "area",
    USER: "user",
    OLD_ADDRESS: "addresses",

    CART: "cart",
    WEB_DEVICE_ID: "webDeviceId",
    WEB_DEVICE_DETAILS: "webDeviceDetails",
    WEB_NOTIFICATION_TOKEN: "webNotificationToken",

    MOBILE_APP_DEVICE_TYPE: "mobileAppDeviceType",
    MOBILE_APP_DEVICE_ID: "mobileAppDeviceId",
    MOBILE_APP_DEVICE_DETAILS: "mobileAppDeviceDetails",
    MOBILE_APP_NOTIFICATION_TOKEN: "mobileAppNotificationToken",
    MOBILE_APP_LOCATION: "mobileAppLocation",
  };

  static get(key) {
    const value = localStorage.getItem(key);
    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return value;
    }
  }

  static set(key, value) {
    let valueToStore = value;
    if (typeof value === "object") {
      valueToStore = JSON.stringify(value);
    }
    console.log("LocalStorageUtils.set", key, valueToStore);
    localStorage.setItem(key, valueToStore);
  }

  static remove(key) {
    localStorage.removeItem(key);
  }

  static getAreaId() {
    return this.get(this.LOCAL_STORAGE_KEY.AREA_ID);
  }


  static saveArea(area) {
    area.cachedAt = new Date().getTime();
    this.set(this.LOCAL_STORAGE_KEY.AREA, area);
  }

  static getArea() {
    const area = this.get(this.LOCAL_STORAGE_KEY.AREA);
    return area;
  }

  static getUiTabList() {
    const area = this.getArea();
    return area?.extraDetails?.ui.tab;
  }


  static cartKey() {
    const areaId = this.getAreaId();
    return `${areaId}_${this.LOCAL_STORAGE_KEY.CART}`;
  }

  static getCart() {
    return this.get(this.cartKey()) ?? {};
  }

  static removeCart() {
    this.remove(this.cartKey());
  }

  static setCart(cart) {
    this.set(this.cartKey(), cart);
  }

  static getUserId() {
    return this.get(this.LOCAL_STORAGE_KEY.USER)?.userId;
  }
}
